"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionSingleColorIcon20 = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const CollectionSingleColorIcon20 = _ref => {
  let {
    color,
    backgroundColor,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "none",
    viewBox: "0 0 20 20"
  }, rest), /*#__PURE__*/_react.default.createElement("path", {
    fill: backgroundColor,
    d: "M3 6v8a3 3 0 0 0 3 3h8c1.657 0 3-1.34 3-2.997V5.998A3 3 0 0 0 14 3H6a3 3 0 0 0-3 3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: backgroundColor,
    d: "M12.467 3.7H7.55v8.316a.5.5 0 0 0 .827.378l1.316-1.14a.5.5 0 0 1 .657.001l1.288 1.129a.5.5 0 0 0 .83-.376z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M4.4 6v8A1.6 1.6 0 0 0 6 15.6h8c.886 0 1.6-.715 1.6-1.597V5.998c0-.883-.715-1.598-1.6-1.598H6A1.6 1.6 0 0 0 4.4 6M3 14V6a3 3 0 0 1 3-3h8c1.657 0 3 1.34 3 2.998v8.005A2.997 2.997 0 0 1 14 17H6a3 3 0 0 1-3-3",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M6.85 3.7a.7.7 0 0 1 .7-.7h4.917a.7.7 0 0 1 .7.7v8.308c0 1.031-1.215 1.582-1.99.902l-1.157-1.013-1.184 1.026c-.777.673-1.986.121-1.986-.907zm1.4.7v7.178l.985-.853a1.2 1.2 0 0 1 1.577.004l.956.838V4.4zm-.331 7.465",
    clipRule: "evenodd"
  }));
};
exports.CollectionSingleColorIcon20 = CollectionSingleColorIcon20;
//# sourceMappingURL=CollectionSingleColorIcon20.js.map